import { useOrgFeatureFlags } from '@frontend/get-org-data';

export const useWeaveAssistantSettingsFeatureFlag = () => {
  const { getFeatureFlagAllEnabled } = useOrgFeatureFlags();
  return getFeatureFlagAllEnabled('next-gen-settings');
};
